"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Thermometer = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "thermometer" },
            react_1.default.createElement("path", { id: "Icon", d: "M9.5 13.7578L10.0563 14.5888C10.3336 14.4032 10.5 14.0915 10.5 13.7578H9.5ZM14.5 13.7578H13.5C13.5 14.0915 13.6664 14.4032 13.9437 14.5888L14.5 13.7578ZM10.5 13.7578V4.5H8.5V13.7578H10.5ZM8.5 17.5C8.5 16.2875 9.11575 15.2183 10.0563 14.5888L8.94374 12.9268C7.47228 13.9117 6.5 15.5921 6.5 17.5H8.5ZM12 21C10.067 21 8.5 19.433 8.5 17.5H6.5C6.5 20.5376 8.96243 23 12 23V21ZM15.5 17.5C15.5 19.433 13.933 21 12 21V23C15.0376 23 17.5 20.5376 17.5 17.5H15.5ZM13.9437 14.5888C14.8842 15.2183 15.5 16.2875 15.5 17.5H17.5C17.5 15.5921 16.5277 13.9117 15.0563 12.9268L13.9437 14.5888ZM13.5 4.5V13.7578H15.5V4.5H13.5ZM12 3C12.8284 3 13.5 3.67157 13.5 4.5H15.5C15.5 2.567 13.933 1 12 1V3ZM12 1C10.067 1 8.5 2.567 8.5 4.5H10.5C10.5 3.67157 11.1716 3 12 3V1ZM12 17.5V19.5C13.1046 19.5 14 18.6046 14 17.5H12ZM12 17.5H10C10 18.6046 10.8954 19.5 12 19.5V17.5ZM12 17.5V15.5C10.8954 15.5 10 16.3954 10 17.5H12ZM12 17.5H14C14 16.3954 13.1046 15.5 12 15.5V17.5Z" }))));
};
exports.default = Thermometer;
